import { VerifiedIcon, ChevronDown } from "lucide-react"

type ExperienceEntryProps = {
  company: string
  position: string
  dateRange: string
  responsibilities: string[]
}

function ExperienceEntry({ company, position, dateRange, responsibilities }: ExperienceEntryProps) {
  return (
    <div className="bg-purple-50/70 rounded-lg p-4 mb-4">
      <h3 className="font-medium text-lg">{company}</h3>
      <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
        <span>{position}</span>
      </div>
      <div className="flex items-center gap-2 text-sm text-gray-500 mt-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>{dateRange}</span>
      </div>

      <ul className="mt-3 space-y-2">
        {responsibilities.map((responsibility, index) => (
          <li key={index} className="text-sm text-gray-600">
            • {responsibility}
          </li>
        ))}
      </ul>

      <div className="flex items-center justify-between mt-4">
        <button className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700">
          <VerifiedIcon className="w-4 h-4" />
          Verify
        </button>
        <button className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700">
          View more
          <ChevronDown className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}

type ResponsibilityEntryProps = {
  title: string
  organization: string
  dateRange: string
  description: string
}

function ResponsibilityEntry({ title, organization, dateRange, description }: ResponsibilityEntryProps) {
  return (
    <div className="border rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <h3 className="font-medium text-lg">{title}</h3>
        <button className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700">
          <VerifiedIcon className="w-4 h-4" />
          Verify
        </button>
      </div>
      <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
        </svg>
        <span>{organization}</span>
      </div>
      <div className="flex items-center gap-2 text-sm text-gray-500 mt-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>{dateRange}</span>
      </div>

      <p className="text-sm text-gray-600 mt-3">{description}</p>
    </div>
  )
}

export default function ExperienceSection() {
  const internships = [
    {
      company: "Macrosoft",
      position: "Software Developer - Intern",
      dateRange: "Jul 2024 - Present",
      responsibilities: [
        "Assisted in developing and debugging web applications using JavaScript, Python, and React",
        "Collaborated with senior developers on feature implementations and code reviews",
      ],
    },
    {
      company: "Macrosoft",
      position: "Software Developer - Intern",
      dateRange: "Jul 2024 - Present",
      responsibilities: [
        "Assisted in developing and debugging web applications using JavaScript, Python, and React",
        "Collaborated with senior developers on feature implementations and code reviews",
      ],
    },
    {
      company: "Macrosoft",
      position: "Software Developer - Intern",
      dateRange: "Jul 2024 - Present",
      responsibilities: [
        "Assisted in developing and debugging web applications using JavaScript, Python, and React",
        "Collaborated with senior developers on feature implementations and code reviews",
      ],
    },
    {
      company: "Macrosoft",
      position: "Software Developer - Intern",
      dateRange: "Jul 2024 - Present",
      responsibilities: [
        "Assisted in developing and debugging web applications using JavaScript, Python, and React",
        "Collaborated with senior developers on feature implementations and code reviews",
      ],
    },
  ]

  const responsibilities = [
    {
      title: "Technical Head",
      organization: "CodeC - Computer Science Club",
      dateRange: "Jul 2024 - Present",
      description:
        "Lorem ipsum dolor sit amet consectetur. Fringilla fermentum aliquam potentis eu egestas vestibulum massa. Nunc quis magna urget aliquam nunc lacinia nunc. A velit consequat et lacinia aliquam sed quis viverra pulvinar.",
    },
    {
      title: "Technical Head",
      organization: "CodeC - Computer Science Club",
      dateRange: "Jul 2024 - Present",
      description:
        "Lorem ipsum dolor sit amet consectetur. Fringilla fermentum aliquam potentis eu egestas vestibulum massa. Nunc quis magna urget aliquam nunc lacinia nunc. A velit consequat et lacinia aliquam sed quis viverra pulvinar.",
    },
    {
      title: "Technical Head",
      organization: "CodeC - Computer Science Club",
      dateRange: "Jul 2024 - Present",
      description:
        "Lorem ipsum dolor sit amet consectetur. Fringilla fermentum aliquam potentis eu egestas vestibulum massa. Nunc quis magna urget aliquam nunc lacinia nunc. A velit consequat et lacinia aliquam sed quis viverra pulvinar.",
    },
    {
      title: "Technical Head",
      organization: "CodeC - Computer Science Club",
      dateRange: "Jul 2024 - Present",
      description:
        "Lorem ipsum dolor sit amet consectetur. Fringilla fermentum aliquam potentis eu egestas vestibulum massa. Nunc quis magna urget aliquam nunc lacinia nunc. A velit consequat et lacinia aliquam sed quis viverra pulvinar.",
    },
  ]

  return (
    <>
      <section className="px-6 pb-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="bg-purple-100 p-1 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-purple-500"
            >
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
          </div>
          <h2 className="font-medium">Internship Experience</h2>
        </div>

        {internships.map((internship, index) => (
          <ExperienceEntry key={index} {...internship} />
        ))}
      </section>

      <section className="px-6 pb-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="bg-orange-100 p-1 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-orange-500"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <h2 className="font-medium">Positions of Responsibility</h2>
        </div>

        {responsibilities.map((responsibility, index) => (
          <ResponsibilityEntry key={index} {...responsibility} />
        ))}
      </section>
    </>
  )
}

